import { combineReducers } from 'redux';

import editingDocumentId from './editingDocumentId';
import ids from './ids';
import idsInPages from './idsInPages';
import information from './information';
import isInserting from './isInserting';
import isInsertInProgress from './isInsertInProgress';
import isNewEditingDocument from './isNewEditingDocument';
import latestFieldIDByType from './latestFieldIDByType';
import positions from './positions';
import sizes from './sizes';
import target from './target';
import url from './url';

const editingDocumentReducer = combineReducers({
  editingDocumentId,
  ids,
  idsInPages,
  information,
  isInserting,
  isInsertInProgress,
  isNewEditingDocument,
  latestFieldIDByType,
  positions,
  sizes,
  target,
  url,
});

export default editingDocumentReducer;

export type EditingDocumentState = ReturnType<typeof editingDocumentReducer>;
